import InfoItem from "../../../../../components/common/InfoItem";
import { formatDate } from "../../../../../lib/time";
import { GetSingleUserDataType } from "../../../../../types/portal/user";
import { underscoreToCapitalizeString } from "../../../../../utils/utils";
import EditButtonEmployee from "./EditButtonEmployee";

type Props = {
  data?: GetSingleUserDataType;
};

export default function OfficialInfo({ data }: Props) {
  return (
    <div className="employee_info_item">
      <InfoItem title="Name">{data?.data?.name}</InfoItem>
      <InfoItem title="Username">{data?.data?.username}</InfoItem>
      <InfoItem title="Email">{data?.data?.email}</InfoItem>
      <InfoItem title="Department">{data?.data?.department?.name}</InfoItem>
      <InfoItem title="Functional Designation">
        {data?.data?.sub_department?.name}
      </InfoItem>
      <InfoItem title="HR Designation">{data?.data?.hr_designation}</InfoItem>
      <InfoItem title="Manager">{data?.data?.manager?.name}</InfoItem>
      <InfoItem title="Date of joining">
        {data?.data?.join_date ? formatDate(data?.data?.join_date) : undefined}
      </InfoItem>
      <InfoItem title="Employee Type">
        {data?.data?.employee_type
          ? underscoreToCapitalizeString(data?.data?.employee_type)
          : undefined}
      </InfoItem>
      <InfoItem title="Employee ID">{data?.data?.employee_id}</InfoItem>
      {/* TODO: */}
      {/* <InfoItem title="RFID">{data?.data?.rfid || "N/A"}</InfoItem>  */}
      <InfoItem title="Grade">{data?.data?.grade}</InfoItem>
      {/* <InfoItem title="Expense Unit">{data?.data?.name}</InfoItem> */}
      <InfoItem title="Business Unit">
        {data?.data?.business_unit?.name}
      </InfoItem>
      <InfoItem title="Work Station">{data?.data?.work_station?.name}</InfoItem>
      {data?.data?.status !== "invited" && (
        <EditButtonEmployee type="Official" />
      )}
    </div>
  );
}
